import type { Form, FormField, FormSection } from '../../interfaces/form.interface';
import { InputType } from '../../interfaces/input.interface';

/** Provides read-only lookup helpers for form fields. */
export class FormFieldFinder<T> {
    constructor(private readonly form: Form<T>) {}

    public getFields(): FormField<T>[] {
        return this.form.sections.flatMap(section => section.fields);
    }

    public getFieldByControlName(controlName: string | undefined): FormField<T> | undefined {
        const normalizedControlName = String(controlName ?? '').trim();

        if (!normalizedControlName) {
            return undefined;
        }

        const matchingFields = this.getSectionFields()
            .filter(({ field }) => field.name === normalizedControlName);

        return matchingFields.find(({ section, field }) => this.isPreferredRuntimeField(section, field))?.field
            ?? matchingFields[0]?.field;
    }

    private getSectionFields(): Array<{ section: FormSection<T>; field: FormField<T> }> {
        return this.form.sections.flatMap((section) =>
            section.fields.map((field) => ({ section, field }))
        );
    }

    private isPreferredRuntimeField(section: FormSection<T>, field: FormField<T>): boolean {
        return section.isVisible &&
            field.conditions.isVisible &&
            field.input?.type !== InputType.HIDDEN &&
            field.input?.type !== InputType.EMPTY;
    }
}
